/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_Offline_DetailInputs */

const en_us2_shell_offline_detail = /** @type {(inputs: Shell_Offline_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your workouts and changes are saved and sync when the connection is back.`)
};

const pt_br2_shell_offline_detail = /** @type {(inputs: Shell_Offline_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus treinos e alterações ficam salvos e sincronizam quando a conexão voltar.`)
};

const es_419_shell_offline_detail = /** @type {(inputs: Shell_Offline_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus entrenamientos y cambios quedan guardados y se sincronizan cuando vuelva la conexión.`)
};

const pt_pt2_shell_offline_detail = /** @type {(inputs: Shell_Offline_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os teus treinos e alterações ficam guardados e sincronizam quando a ligação voltar.`)
};

const fr_fr2_shell_offline_detail = /** @type {(inputs: Shell_Offline_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes séances et modifications sont enregistrées et se synchronisent au retour de la connexion.`)
};

const de_de2_shell_offline_detail = /** @type {(inputs: Shell_Offline_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Trainings und Änderungen sind gespeichert und werden synchronisiert, sobald die Verbindung zurück ist.`)
};

const it_it2_shell_offline_detail = /** @type {(inputs: Shell_Offline_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi allenamenti e le modifiche restano salvati e si sincronizzano quando torna la connessione.`)
};

/**
* | output |
* | --- |
* | "Your workouts and changes are saved and sync when the connection is back." |
*
* @param {Shell_Offline_DetailInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_offline_detail = /** @type {((inputs?: Shell_Offline_DetailInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Offline_DetailInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_offline_detail(inputs)
	if (locale === "es-419") return es_419_shell_offline_detail(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_offline_detail(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_offline_detail(inputs)
	if (locale === "de-DE") return de_de2_shell_offline_detail(inputs)
	if (locale === "it-IT") return it_it2_shell_offline_detail(inputs)
	return en_us2_shell_offline_detail(inputs)
});
export { shell_offline_detail as "shell.offline_detail" }